<template>
    <div>
        <div class="card mb-3" id="regInfo-list">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mb-2 text-center">
                        <h4>لطفا اطلاعات مالیاتی خود را وارد کنید و هرگز تغییر ندهید</h4>
                        <a target="_blank" href="https://csr.orash.ir/">راهنمای دریافت اطلاعات
                            مالیاتی</a>
                    </div>
                    <div class="col-lg-4 mb-2">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام کاربر</span>
                            </div>
                            <input class="form-control" type="text" disabled="true" v-model="regInfo.fullName" placeholder="بصورت اتوماتیک پر میشود">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-2">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد اقتصادی(کد ملی +0001)</span>
                            </div>
                            <input class="form-control" type="text" v-model="regInfo.tins">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-2">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شناسه یکتای مالیاتی</span>
                            </div>
                            <input class="form-control" type="text" dir="ltr" placeholder="A2P..." v-model="regInfo.memorY_ID">
                        </div>
                    </div>

                    <div class="col-lg-12 mb-2">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کلید خصوصی</span>
                            </div>
                            <textarea class="form-control" cols="15" style="height: 200px;" dir="ltr" placeholder="-----BEGIN PRIVATE KEY-----MIIBOgIBAAJBAKj34GkxFhD90vcNLIn..."
                                      v-model="regInfo.private_KEY"></textarea>
                        </div>
                    </div>
                    <div class="col-lg-12 mb-2">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">امضای دیجیتال</span>
                            </div>
                            <textarea class="form-control" cols="15" style="height: 200px;" dir="ltr" placeholder="-----BEGIN CERTIFICATE-----MIID0DCCArigAwIBAgIBATANBgkqhk..."
                                      v-model="regInfo.certificate_KEY"></textarea>
                        </div>
                    </div>
                    <div class="col-lg-12 mb-2 text-center">
                        <button type="button" class="btn btn-primary m-0" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";
    import EventBus from "../../_framework/event-bus.js";
    import Moment from "moment-jalali";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'register',
        components: {VsSelect},
        data() {
            return {
                regInfos: [],
                queryParams: {
                    pageSize: 8,
                    pageIndex: 0,
                    name: "",
                    types: 1
                },
                preselectedregInfo: {},
                preselectedAccountType: {},
                regInfo: {
                    userId: 0,
                    companyId: 0,
                    memorY_ID: "",
                    private_KEY: "",
                    certificate_KEY: "",
                    fullName: "",
                    postName: "",
                    tins: "",

                },

                params: {
                    mode: 'create'
                },
                searchString: "",

                transactions: [],
                listView: true,
                transactionsQuery: {
                    pageSize: 8,
                    pageIndex: 0,
                    code: 0
                },
                dataCount: 0,
                transactionCount: 0,

                autoload: false,
                isSending: false,

            }
        },
        mounted() {
            this.getregInfos();

        },
        methods: {
            getregInfos() {

                $("#loading").show();
                new BaseService('TaxService', '/GetRegisterationInfo').getList().then(response => {
                    if (response.data !== null && response.data !== "") {
                        this.regInfo = response.data;
                    }
                    $("#loading").hide();
                }).catch(error => {
                    $("#loading").hide();
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onModalOk() {
                if (this.regInfo.memorY_ID === null || this.regInfo.memorY_ID === '' || this.regInfo.memorY_ID.length < 5) {
                    Utils.handleErrorWithNotification("لطفا شناسه یکتای مالیاتی را وارد کنید", this.$noty);
                } else if (this.regInfo.private_KEY === null || this.regInfo.private_KEY === '' || this.regInfo.private_KEY.length < 10) {
                    Utils.handleErrorWithNotification("لطفا کلید خصوصی را وارد کنید", this.$noty);
                } else if (this.regInfo.certificate_KEY === null || this.regInfo.certificate_KEY === '' || this.regInfo.certificate_KEY.length < 10) {
                    Utils.handleErrorWithNotification("لطفا امضای دیجیتال را وارد کنید", this.$noty);
                } else if (this.regInfo.tins === null || this.regInfo.tins === '' || this.regInfo.tins.length < 9) {
                    Utils.handleErrorWithNotification("لطفا کد اقتصادی را وارد کنید", this.$noty);
                } else {
                    this.onCreate(this.regInfo);
                }
            },
            onCreate(regInfo) {
                if (!this.isSending) {
                    this.isSending = true;
                    new BaseService('TaxService/UpdateRegisterationInfo').update(regInfo).then(response => {
                        this.$noty.success("اطلاعات با موفقیت ویرایش شد.");

                        this.isSending = false;
                        this.$router.push({
                            name: 'taxService',

                        });
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#regInfo-modal").hasClass("show")) {
                $("#regInfo-modal").modal("hide");
                next(false);
            } else {
                if ($("#transactionModal").hasClass("show")) {
                    $("#transactionModal").modal("hide");

                    next(false);
                } else {
                    next();
                }
            }


        },
    }
</script>